import { __rest } from 'tslib';
import { jsx, jsxs } from 'react/jsx-runtime';
import { styled, ButtonGroup } from '@mui/material';
import Button from './Button.js';
import OverflowWindow from '../OverflowWindow/OverflowWindow.js';
import '../OverflowWindow/OverflowProvider.js';
import '../OverflowWindow/components/MenuCategory.js';
import '../OverflowWindow/components/ChecklistItems.js';
import '../OverflowWindow/components/MenuItem.js';
import '../OverflowWindow/components/SubMenuItem.js';
import 'react';
import '../OverflowWindow/components/CascadingProvider.js';
import { ReactComponent as ForwardRef } from '../../assets/icons/OutlineArrowDownMedium.svg.js';

const _ButtonGroup = styled(ButtonGroup) `
  ${({ theme, disabled }) => {
    return `
      .MuiButtonGroup-grouped {
        min-width: unset;
      }
      ${disabled &&
        `
        & .MuiButtonGroup-grouped:not(:last-of-type).Mui-disabled {
          border-color: ${theme.palette.N30.main};
        }
        `}
    `;
}}
`;
const SplitButton = (_a) => {
    var { text, variant = 'primary', size = 'medium', disabled, onClick, children } = _a, rest = __rest(_a, ["text", "variant", "size", "disabled", "onClick", "children"]);
    const toggle = (jsx(Button, Object.assign({ variant: variant, size: size, disabled: disabled }, { children: jsx(ForwardRef, {}) })));
    return (jsxs(_ButtonGroup, Object.assign({ variant: "contained", disabled: disabled, disableRipple: true }, { children: [jsx(Button, Object.assign({ variant: variant, size: size, disabled: disabled, onClick: onClick }, rest, { children: text })), disabled ? toggle : jsx(OverflowWindow, Object.assign({ target: toggle }, { children: children }))] })));
};

export { SplitButton as default };
//# sourceMappingURL=SplitButton.js.map
